import { useNavigationHelper, useTargetBrandConfig } from 'FrontRoyalAngular';
import { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { SidebarBoxKey } from 'AdmissionsGuidance';
import { BasicMobileBox } from '../../BasicMobileBox';
import { BasicDesktopBox } from '../../BasicDesktopBox';
import { type ButtonConfig } from '../../StudentDashboardSidebar.types';

function FindFriendsBoxComponent({ mobile }: { mobile?: boolean }) {
    const brandConfig = useTargetBrandConfig();
    const { loadRoute } = useNavigationHelper();
    const { t } = useTranslation('back_royal', { keyPrefix: 'findFriendsBox' });

    const buttons = useMemo(
        () => [
            {
                id: 'button_view_students_and_alumni',
                text: t('button_view_students_and_alumni'),
                onPress: () => loadRoute('/student-network/people'),
            },
        ],
        [loadRoute, t],
    );

    return mobile ? (
        <FindFriendsBoxMobilePresentation
            institutionName={brandConfig.brandNameShort}
            onPress={buttons[0].onPress}
            buttonId={buttons[0].id}
        />
    ) : (
        <FindFriendsBoxPresentation institutionName={brandConfig.brandNameShort} buttons={buttons} />
    );
}

function FindFriendsBoxMobilePresentation({
    institutionName,
    onPress,
    buttonId,
}: {
    institutionName: string;
    onPress: () => void;
    buttonId: string;
}) {
    const { t } = useTranslation('back_royal', { keyPrefix: 'findFriendsBox' });
    return (
        <BasicMobileBox
            boxKey={SidebarBoxKey.find_friends}
            heading={t('heading', { institutionName })}
            onPress={onPress}
            buttonId={buttonId}
            ctaText={t('button_view_students_and_alumni')!}
        />
    );
}

function FindFriendsBoxPresentation({
    institutionName,
    buttons,
}: {
    institutionName: string;
    buttons: ButtonConfig[];
}) {
    const { t } = useTranslation('back_royal', { keyPrefix: 'findFriendsBox' });
    return (
        <BasicDesktopBox
            headerText={t('heading', { institutionName })}
            buttons={buttons}
            boxKey={SidebarBoxKey.find_friends}
        >
            {t('content')}
        </BasicDesktopBox>
    );
}

export const FindFriendsBox = memo(FindFriendsBoxComponent);
